import { truncate } from 'utils/numbers';

export const formatData = value => {
  const positive = value >= 0;
  return `${positive ? '+' : ''}${truncate(value)}%`;
};
